import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router';
import { Grid, Form, Button, Modal, Header, Icon } from 'semantic-ui-react';
import { Field, reduxForm } from 'redux-form';
import ReactTable from 'react-table';
import { connect } from 'react-redux';

import { DAILY_DEPOSIT_FORM_NAME } from 'Common/FormEnum';
import CashCalculator from 'Common/Components/CashCalculator/CashCalculator';
import { computeTotal } from 'Common/Components/CashCalculator/helpers/compute';
import { InputField } from 'Common/SemanticWrapper';
import { DailyDepositFieldEnum as Fields } from 'Common/FieldEnum';
import { formatDecimal, formatToCash } from 'Common/FormHelper';
import { setNotificationDialog } from 'Components/dialogs/state/actions';

import { SiteFieldEnum } from '../helpers/DailyDepositHelpers';
import {
  MealSummaryColumns,
  DenominationFields,
} from '../helpers/DailyDepositHelpers';

class SiteTable extends Component {
  SiteColumns = [
    { Header: 'Site', accessor: SiteFieldEnum.SiteId },
    {
      Header: (
        <span>
          Attendance
          <br />
          Factor
        </span>
      ),
      Cell: (row) => (
        <Field
          label={false}
          compact
          component={InputField}
          name={`${Fields.Sites}[${row.index}].${SiteFieldEnum.AttendanceFactor}`}
          formatOnBlur={formatDecimal(2)}
          handleBlur={this.props.onAttendanceBlur(true, row.index)}
          maxLength={6}
          hideEmptyError
          disabled={this.props.disabled}
        />
      ),
    },
    {
      Header: 'Attendance',
      Cell: (row) => (
        <Field
          label={false}
          compact
          component={InputField}
          name={`${Fields.Sites}[${row.index}].${SiteFieldEnum.Attendance}`}
          handleBlur={this.props.onAttendanceBlur(false, row.index)}
          maxLength={6}
          hideEmptyError
          disabled={this.props.disabled}
        />
      ),
    },
    { Header: 'Membership', accessor: SiteFieldEnum.Membership },
    {
      Header: (
        <span>
          Max
          <br />
          Free
        </span>
      ),
      width: 70,
      accessor: SiteFieldEnum.MaxFree,
    },
    {
      Header: (
        <span>
          Allowed
          <br />
          Free
        </span>
      ),
      width: 70,
      accessor: SiteFieldEnum.AllowedFree,
    },
    {
      Header: (
        <span>
          Max
          <br />
          Reduced
        </span>
      ),
      width: 70,
      accessor: SiteFieldEnum.MaxReduced,
    },
    {
      Header: (
        <span>
          Allowed
          <br />
          Reduced
        </span>
      ),
      width: 70,
      accessor: SiteFieldEnum.AllowedReduced,
    },
    {
      Header: (
        <span>
          Max
          <br />
          Paid
        </span>
      ),
      width: 70,
      accessor: SiteFieldEnum.MaxPaid,
    },
    {
      Header: (
        <span>
          Allowed
          <br />
          Paid
        </span>
      ),
      width: 70,
      accessor: SiteFieldEnum.AllowedPaid,
    },
  ];

  render() {
    const error = this.props.meta.error;
    return (
      <Fragment>
        {error ? <span className={'text-red'}>{error}</span> : undefined}
        <ReactTable
          data={this.props.formValues[Fields.Sites]}
          columns={this.SiteColumns}
          minRows={1}
          disabled={this.props.loading}
          showFilters={false}
          showPagination={false}
          {...this.props}
          getTrProps={() => ({
            style: {
              lineHeight: '40px',
            },
          })}
        />
      </Fragment>
    );
  }
}

class DailyDepositFormContainer extends Component {
  state = {
    showDetailsModal: false,
    showCalculatorModal: false,
  };

  getDetailsModal = () => {
    return (
      <Modal size="small" open={this.state.showDetailsModal}>
        <Header icon="info circle" content={'Meal Summary'} />
        <Modal.Content scrolling>
          <ReactTable
            data={this.props.mealSummaries}
            columns={MealSummaryColumns}
            minRows={5}
            defaultPageSize={10}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button
            primary
            onClick={() => {
              this.setState({
                showDetailsModal: false,
              });
            }}
          >
            <Icon className={'icon--white'} name="checkmark" />
            OK
          </Button>
        </Modal.Actions>
      </Modal>
    );
  };

  getCalculatorModal = () => {
    const { showCalculatorModal } = this.state;
    const { checks, denominations, loading, onGetChecksClick } = this.props;

    return (
      <Modal size="large" open={showCalculatorModal}>
        <Header icon="info circle" content={'Cash Calculator'} />
        <Modal.Content>
          <CashCalculator
            onChange={this.onCalculatorChange}
            onGetChecksClick={onGetChecksClick}
            checks={checks}
            loading={loading}
            denominations={denominations}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button
            primary
            onClick={() => {
              this.setState({
                showCalculatorModal: false,
              });
            }}
          >
            <Icon className={'icon--white'} name="checkmark" />
            OK
          </Button>
        </Modal.Actions>
      </Modal>
    );
  };

  onCalculatorChange = (total, denominations, checks) => {
    const { change } = this.props;

    change(Fields.Checks, checks);
    Object.keys(denominations).forEach((key) =>
      change(key, denominations[key])
    );
    change(Fields.Deposit, total);
  };

  clearCashChecks = () => {
    const { usingCashCalculator } = this;
    if (!usingCashCalculator) {
      const { change } = this.props;
      DenominationFields.forEach((d) => change(d, 0));
      change(Fields.Checks, []);
    }
  };

  get usingCashCalculator() {
    const { checks, denominations } = this.props;
    return checks.length > 0 || Number(computeTotal(denominations, checks)) > 0;
  }

  getWarningsModal = () => {
    const {
      showWarningModal,
      warningModalWarnings,
      warningModalErrors,
      confirmWarnings,
      closeWarnings,
    } = this.props;

    return (
      <Modal size="small" open={showWarningModal}>
        <Header
          icon={warningModalErrors ? 'warning sign' : 'info circle'}
          content={warningModalErrors ? 'Error' : 'Warning'}
        />
        <Modal.Content>
          {warningModalWarnings &&
            warningModalWarnings.map((warning, index) =>
              warning.split('\n').map((msg, i) => (
                <span key={i}>
                  {msg}
                  <br />
                </span>
              ))
            )}
          {warningModalErrors &&
            warningModalErrors.map((error, index) => (
              <span key={index}>
                {error}
                <br />
              </span>
            ))}
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={closeWarnings}>
            <Icon className={'icon--white'} name="cancel" />
            Cancel
          </Button>
          {!warningModalErrors && (
            <Button primary onClick={confirmWarnings}>
              <Icon className={'icon--white'} name="checkmark" />
              Continue
            </Button>
          )}
        </Modal.Actions>
      </Modal>
    );
  };

  handleCashCalculatorOpen = () => {
    const { usingCashCalculator } = this;
    const { denominations, checks, change, formValues } = this.props;
    const { [Fields.Deposit]: depositAmount } = formValues;
    const total = computeTotal(denominations, checks);

    if (!usingCashCalculator && Number(total) !== Number(depositAmount)) {
      this.clearCashChecks();
      change(Fields.Deposit, '0.00');
    }
  };

  render() {
    const { formValues, shouldDisableEditing, onAttendanceBlur } = this.props;

    return (
      <Fragment>
        <Form name={DAILY_DEPOSIT_FORM_NAME}>
          <Grid>
            {formValues && formValues[Fields.IsClosed] && (
              <Grid.Row>
                <Grid.Column className={'text-red'}>
                  This day is closed and cannot be edited.
                </Grid.Column>
              </Grid.Row>
            )}
            <Grid.Row>
              <Grid.Column className={'tight'} width={2}>
                <Field
                  compact
                  label={'Misc 1'}
                  component={InputField}
                  name={Fields.Misc1}
                  formatOnBlur={formatToCash}
                  disabled={shouldDisableEditing}
                  maxLength={6}
                  hideEmptyError
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <Field
                  compact
                  label={'Misc 2'}
                  component={InputField}
                  name={Fields.Misc2}
                  formatOnBlur={formatToCash}
                  readOnly={shouldDisableEditing}
                  maxLength={6}
                  hideEmptyError
                />
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  label={'Labor Hours'}
                  compact
                  component={InputField}
                  name={Fields.LaborHours}
                  formatOnBlur={formatToCash}
                  readOnly={shouldDisableEditing}
                  maxLength={6}
                  hideEmptyError
                />
              </Grid.Column>
              <Grid.Column
                width={2}
                textAlign={'right'}
                verticalAlign={'bottom'}
              >
                <Button
                  content={'Details'}
                  onClick={() => {
                    this.setState({ showDetailsModal: true });
                  }}
                />
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  label={'Deposit'}
                  compact
                  component={InputField}
                  name={Fields.Deposit}
                  formatOnBlur={formatToCash}
                  readOnly={shouldDisableEditing}
                  onChange={this.clearCashChecks}
                  maxLength={8}
                  hideEmptyError
                />
              </Grid.Column>
              <Grid.Column width={4} verticalAlign={'bottom'}>
                <Button
                  content={'Cash Calculator'}
                  onClick={() => {
                    this.handleCashCalculatorOpen();
                    this.setState({
                      showCalculatorModal: true,
                    });
                  }}
                  disabled={shouldDisableEditing}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  component={SiteTable}
                  name={Fields.Sites}
                  disabled={shouldDisableEditing}
                  formValues={formValues !== undefined ? formValues : []}
                  onAttendanceBlur={onAttendanceBlur}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  label={'Comments'}
                  component={InputField}
                  name={Fields.Comments}
                  maxLength={255}
                  readOnly={shouldDisableEditing}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
        {this.getDetailsModal()}
        {this.getWarningsModal()}
        {this.getCalculatorModal()}
      </Fragment>
    );
  }
}

const mapDispatchToProps = {
  setNotificationDialog,
};

DailyDepositFormContainer = connect(
  null,
  mapDispatchToProps
)(DailyDepositFormContainer);

const DailyDepositForm = reduxForm({
  form: DAILY_DEPOSIT_FORM_NAME,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(withRouter(DailyDepositFormContainer));

export { DailyDepositForm };



// WEBPACK FOOTER //
// ./src/pages/dailydeposit/components/DailyDepositForm.js